'use strict';

var App = require('app');
var i18n = require('utils/i18n');

var ProfilePhoneDialog = Marionette.ItemView.extend({
    activeTab: 1,
    codeLength: 6,
    ui: {
        btnPrev: '#js-btn-prev',
        btnNext: '#js-btn-next',
        btnSave: '#js-btn-save',
        edtPhone: 'input.js-phone',
        edtCode: 'input.js-code',
    },

    events: {
        'keyup .js-phone': function (e) {
            this.ui.btnNext.prop('disabled', !this.canNext());
        },

        'keyup .js-code': function (e) {
            this.ui.btnSave.prop('disabled', !this.canFinish());
        },

        'click #js-btn-prev': function (e) {
            this.activeTab = 1;
            this.render();
        },

        'click #js-btn-next': function (e) {
            this.phone = this.ui.edtPhone.val().trim();
            var isValid = this.validate();
            this.waitNext = isValid;
            this.render();

            if (!isValid) {
                return;
            }

            var self = this;
            var req = App.request('user:phone:getcode', this.phone);
            $.when(req).done(function (e) {
                self.waitNext = false;
                if (e) {
                    self.error = e;
                } else {
                    self.activeTab = 2;
                    self.error = undefined;
                }
                self.render();
            });
        },

        'click #js-btn-save': function (e) {
            this.code = this.ui.edtCode.val().trim();
            var isValid = this.validate();
            this.waitSave = isValid;
            this.render();
            if (!isValid) {
                return;
            }

            var self = this;
            var req = App.request('user:phone:save', this.phone, this.code);
            self.error = undefined;

            $.when(req).done(function (validationError) {
                self.waitSave = false;
                if (validationError) {
                    self.error = validationError;
                    self.activeTab = 2;
                    self.render();
                    return;
                }

                if (self.onSuccess) {
                    self.onSuccess();
                }
            });
        },
    },

    template: require('components/profile/templates/profile_phone_dialog'),

    initialize: function (data) {
        Marionette.ItemView.prototype.initialize(data);
        this.onSuccess = data.onSuccess;
    },

    serializeData: function () {
        var data = Marionette.ItemView.prototype.serializeData.apply(this, arguments);
        data.activeTab = this.activeTab;
        data.canNext = this.canNext();
        data.canFinish = this.canFinish();
        data.phone = this.phone;
        data.code = this.code;
        data.errors = this.getErrors(this.error);
        data.waitSave = this.waitSave;
        data.waitNext = this.waitNext;
        return data;
    },

    getErrors: function (err) {
        var self = this;

        var currentTabErr = function (msg) {
            var key = self.activeTab == 1 ? 'phone' : 'code';
            var errObj = {};
            errObj[key] = msg;
            return errObj;
        };

        switch (err) {
            case 'invalid_number':
            case 'invalid_phone_number': // this one is a reply from the server when checking the code
                return { error: i18n.TR('Ungültige Telefonnummer.') };
            case 'too_many_attempts':
                return currentTabErr(
                    i18n.TR('Zu viele Aktivierungsversuche. Bitte probieren Sie es in einer Stunde noch mal.')
                );
            case 'too_soon_after_last_request':
                return currentTabErr(i18n.TR('Bitte warten Sie 10 Sekunden und probieren Sie es noch mal.'));
            case 'invalid_code':
                return { code: i18n.TR('Der Bestätigungscode ist ungültig.') };
            case 'phone_not_saved':
                return { error: i18n.TR('Die Telefonnummer konnte nicht gespeichert werden.') };
            case 'invalid_request':
                return { error: i18n.TR('Die Anfrage ist fehlgeschlagen.') };
        }

        if (err) {
            return { error: err };
        }
    },

    canNext: function () {
        var phone = $(this.ui.edtPhone).val() || this.phone;
        var result = this.activeTab == 1 && phone;
        return result;
    },

    canFinish: function () {
        var code = $(this.ui.edtCode).val();
        return this.activeTab == 2 && code;
    },

    validate: function () {
        this.error = undefined;
        if (this.activeTab == 1) {
            this.error = this.checkPhoneNumber() ? undefined : 'invalid_number';
        } else {
            this.error = this.code.length == this.codeLength && this.checkCode() ? undefined : 'invalid_code';
        }
        return !this.error;
    },

    checkPhoneNumber: function () {
        var phone = this.phone || '';
        phone = phone.replace(/[\-/\(\) ]+/g, '');

        if (!phone.startsWith('+')) {
            phone = '+49' + phone.substring(phone.startsWith('0') ? 1 : 0);
        }

        var regexPhone = /^\+[0-9]+$/;
        var result = phone.match(regexPhone);
        return result;
    },

    checkCode: function () {
        var regexCode = /^[0-9]+$/;
        var result = this.code.match(regexCode);
        return result;
    },
});

module.exports = ProfilePhoneDialog;
